import Swiper from 'swiper';
import { Autoplay, EffectFade } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/effect-fade';
import CountAction from "@/js/plugins/CountAction";
import { countUpAction } from "@/js/helpers";
import searchListMain, { parentChildCheckbox } from "@/js/components/others/_search-list.js";

const heroSwiper = () => {
    const slider = new Swiper(".pg-home-mv__swiper", {
        // 使用するモジュールを指定
        modules: [Autoplay, EffectFade],

        // autoplay設定
        autoplay: {
            delay: 3000,
            disableOnInteraction: false,
        },
        // fade効果
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        // speed設定
        speed: 2000,
        // ナビゲーション非表示（slickのarrows: falseに相当）
        navigation: false,
        // ページネーション非表示（必要に応じて設定）
        pagination: false,
    });
}


const setSearchArea = () => {
    const setAreaSearchCountAction = (type) => {
        const areaSearchCountAction = new CountAction(document.querySelector(`.pg-home-area-search-area-list__block[data-mode="${type}"] [data-pickup-search]`));
        areaSearchCountAction.on('countChange', (e) => {
            const target = document.querySelector('.pg-home-area-search [data-pickup-count]');
            countUpAction(target, e.count);
            if (e.count == 0) {
                document.querySelector('.pg-home-area-search-result__count').dataset.empty = '';
                document.querySelectorAll('.pg-home-area-search-result__buttons button').forEach(button => button.setAttribute('disabled', ''));
            } else {
                delete document.querySelector('.pg-home-area-search-result__count').dataset.empty;
                document.querySelectorAll('.pg-home-area-search-result__buttons button').forEach(button => button.removeAttribute('disabled'));
            }
            parentChildCheckbox();
        });
    }

    document.querySelector('.pg-home-area-search select').addEventListener('change', (e) => {
        const selectedType = e.currentTarget.value;
        document.querySelector('.pg-home-area-search-result__count').dataset.empty = '';
        document.querySelectorAll('.pg-home-area-search-result__buttons button').forEach(button => button.setAttribute('disabled', ''));
        document.querySelector('.pg-home-area-search-result__count [data-pickup-count]').innerText = '0';
        document.querySelectorAll('.pg-area-search-area-list__block input[type="checkbox"]').forEach(checkbox => {
            checkbox.checked = false;
        });
        document.querySelectorAll('.pg-home-area-search-result__buttons button').forEach(button => button.setAttribute('form', `area-search-form-${selectedType}`));
        document.querySelectorAll('.pg-home-area-search-area-list__block').forEach(block => {
            if (block.dataset.mode === selectedType) {
                block.dataset.isShow = '';
            } else {
                delete block.dataset.isShow;
            }
        });
    });
    document.querySelector('.pg-home-area-search__type select').dispatchEvent(new Event('change'));

    document.querySelectorAll('.pg-home-area-search-area-list__block').forEach(block => {
        const type = block.dataset.mode;
        setAreaSearchCountAction(type);
    });

    document.querySelector('.pg-home-area-search').querySelectorAll('input[type="checkbox"]').forEach(checkbox => {
        checkbox.addEventListener('change', () => {
            setTimeout(() => {
                const count = document.querySelector('.pg-home-area-search').querySelectorAll('input[type="checkbox"]:checked').length;
                console.log(count);
                const target = document.querySelector('.pg-home-area-search__result');
                if (count === 0) {
                    delete target.dataset.fixed;
                } else {
                    target.dataset.fixed = '';
                }
            }, 100);
        });
    });

    searchListMain();
}


const main = () => {
    if (document.querySelector('#page-home') === null) return;
    heroSwiper();
    setSearchArea();
}

export default main
